$(document).on('click', '.js-gallery-place:not(.active)', function(){
    $('.js-gallery-place.active').removeClass('active');
    $(this).addClass('active');
    gallery_filter();
})

function gallery_filter(){
    let place = $('.js-gallery-place.active').data('place');

    if(place){
        $('.gallery-item').hide();
        $('.gallery-item[data-place="'+place+'"]').show();
    }else{
        $('.gallery-item').show();
    }
}
